/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface VideoVisitTokenResponse {
  /** The meeting token */
  token: string;
  /** The name of the room */
  room_name: string;
  /** The URL of the room */
  url: string;
}
